import { useMemo } from "react";

import { SideBar } from "../SideBar";
import { useReportContext } from "../../report-context";

import { ReportColumn } from "@/types/evaluate";

export const useTableConfiguration = () => {
  const reportContext = useReportContext();
  const { sortedColumns } = reportContext;

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivotMode: true,
          },
        },
        {
          id: "display-actions",
          labelDefault: "Display Actions",
          labelKey: "display-actions",
          iconKey: "paintBrush",
          toolPanel: () => <SideBar />,
        },
      ],
    }),
    [],
  );

  const rowNumbers = useMemo(
    () => ({
      suppressCellSelectionIntegration: true,
      enableRowResizer: true,
    }),
    [],
  );

  const gridContextStorageKey = useMemo(
    () => `hiddenColumns_${sortedColumns[0]?.report_id ?? ""}`,
    [sortedColumns],
  );

  const gridContextCustomActions = useMemo(() => {
    const hideDatasetColumns = () => {
      if (!sortedColumns) {
        return;
      }

      const datasetColumns = sortedColumns.filter(
        (col: ReportColumn) => col.column_type === "DATASET",
      );
      const datasetColumnNames = datasetColumns.map((col: ReportColumn) => col.name);

      return datasetColumnNames;
    };

    return { hideDatasetColumns };
  }, [sortedColumns]);

  return {
    sideBar,
    rowNumbers,
    gridContextStorageKey,
    gridContextCustomActions,
  };
};

export default useTableConfiguration;
